import { render } from "./batches.vue?vue&type=template&id=615d70d9"
import script from "./batches.vue?vue&type=script&lang=js"
export * from "./batches.vue?vue&type=script&lang=js"
script.render = render

export default script